;(function() {
    const ajaxCRUD = CommentsLsAjaxCRUD();
    const ajaxHTML = CommentsLsAjaxHTML();

    const CONFIRM = {
        DELETE: "Вы уверены, что хотите удалить комментарий?"
    };

    const commentBody = $(".comments");

    commentBody.on("click", function (event) {
        let target = $(event.target);
        if (target.closest(".comment-toolbar").length === 0) {
            return true;
        }
        if (target[0].tagName !== 'A') {
            target = target.closest("a");
        }

        event.preventDefault();
        const commentCurrent = target.closest(".comment");

        switch (target.attr("data-type")) {
            case "answer":
                btnAnswer(target, commentCurrent);
                break;
            case "update":
                btnUpdate(target, commentCurrent);
                break;
            case "delete":
                btnDelete(target, commentCurrent);
                break;
        }
    });

    function btnAnswer(target, comment) {
        const liContainer = comment.closest("li"),
            id = comment.attr("data-id"),
            message = comment.find(".author-message").text();

        ajaxHTML.insertFormAnswer(target, liContainer, id);
    }

    function btnUpdate(target, comment) {
        const commentBody = comment.closest(".comment"),
            id = comment.attr("data-id"),
            message = comment.find(".author-message").text();

        ajaxHTML.insertFormUpdate(commentBody, id, message);
    }

    function btnDelete(target, comment) {
        if (confirm(CONFIRM.DELETE)) {
            const liContainer = comment.closest("li");
            const commentId = comment.attr("data-id");
            ajaxCRUD.delete(target, liContainer, commentId);
        }
    }
}());
